import actionTypes from '../constants/action-types';

const integrations = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SET_INTEGRATIONS:
      return action.payload.integrations;
    case actionTypes.UPDATE_INTEGRATIONS:
      return {
        ...state,
        ...action.payload.integrations,
      };
    default:
      return state;
  }
};

export default integrations;
